import React from 'react';
import {VideoContainer, ArticleContainer, FactContainer} from './index';
import {useStoreState} from 'easy-peasy';

const QuickFacts = props => {
    const preparedContent = useStoreState(state => state.results.preparedContent);
    const answers         = useStoreState(state => state.answers.current);

    const createPreparedContent = () => {
        const quickFactsContainer = [];
        quickFactsContainer.push(preparedContent[0].contentType === `article` ?
            <ArticleContainer key={`preparedness-content-1`} openArticleModal={props.openArticleModal} data={preparedContent[0]} display={`vertical`} analyticsArgument={`LevelA1`} /> :
            <VideoContainer key={`preparedness-content-1`} openVideoModal={props.openVideoModal} data={preparedContent[0]} display={`vertical`} analyticsArgument={`LevelA1`} />);

        quickFactsContainer.push(preparedContent[1].contentType === `article` ?
            <ArticleContainer key={`preparedness-content-2`} openArticleModal={props.openArticleModal} data={preparedContent[1]} display={`vertical`} analyticsArgument={`LevelA2`} /> :
            <VideoContainer key={`preparedness-content-2`} openVideoModal={props.openVideoModal} data={preparedContent[1]} display={`vertical`} analyticsArgument={`LevelA2`} />);

        return quickFactsContainer;
    };

    return (
        <div className="quick-facts-container">
            <p className="h3">{props.copyData.becauseYouSaid} <span>{answers[2] === `just_starting` ? answers[2].replace(`_`, ` `).concat(` out`) : answers[2].replace(`_`, ` `)}</span></p>
            <div className="facts-content">
                {createPreparedContent()}
                <FactContainer data={props.copyData} analyticsArgument={`${answers[0]}_LevelASource`} />
                <div className="tree-image-container">
                    <img className="illustration" src={`/images/people-with-tree.png`} alt="" role="presentation" />
                </div>
            </div>
        </div>
    );
};

export default QuickFacts;
